import SearchFormInput from './SearchFormInput'

export default SearchFormInput
// eslint-disable-next-line import/export
export * from './SearchFormInput'
